import { render, staticRenderFns } from "./PublicTemplateRenderNew.vue?vue&type=template&id=7adaabf2&scoped=true&"
import script from "./PublicTemplateRenderNew.vue?vue&type=script&lang=ts&"
export * from "./PublicTemplateRenderNew.vue?vue&type=script&lang=ts&"
import style0 from "./PublicTemplateRenderNew.vue?vue&type=style&index=0&id=7adaabf2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adaabf2",
  null
  
)

export default component.exports